import { FormattedMessage } from 'react-intl';

export const AddToCompare = (
  <FormattedMessage
    defaultMessage='Add to compare'
    id='wishlist.addToCompare'
  />
);

export const WatchesSelected = (
  <FormattedMessage
    defaultMessage='Watches selected'
    id='wishlist.watchesSelected'
  />
);

export const StartComparison = (
  <FormattedMessage
    defaultMessage='Start Comparison'
    id='wishlist.startComparison'
  />
);
export const Comparison = (
  <FormattedMessage defaultMessage='Comparison' id='wishlist.comparison' />
);

export const BuckleNotIncluded = (
  <FormattedMessage
    defaultMessage='Buckle not included'
    id='wishlist.buckleNotIncluded'
  />
);

export const OpeningHours = (
  <FormattedMessage defaultMessage='Opening hours' id='wishlist.openingHours' />
);

export const EMail = (
  <FormattedMessage defaultMessage='E-mail' id='wishlist.email' />
);

export const ViewMore = (
  <FormattedMessage defaultMessage='View more' id='wishlist.viewMore' />
);

export const GetDirections = (
  <FormattedMessage
    defaultMessage='Get directions'
    id='wishlist.getDirections'
  />
);
export const Appointment = (
  <FormattedMessage
    defaultMessage='BOOK AN APPOINTMENT'
    id='wishlist.appointment'
  />
);

export const WishListEmpty = (
  <FormattedMessage
    defaultMessage='YOUR WISHLIST IS EMPTY'
    id='wishlist.wishListEmpty'
  />
);

export const Or = <FormattedMessage defaultMessage='or' id='wishlist.or' />;
export const CreateAnAccount = (
  <FormattedMessage
    defaultMessage=' create an account'
    id='wishlist.createAnAccount'
  />
);

export const GoMyAccount = (
  <FormattedMessage
    defaultMessage='GO TO MY ACCOUNT'
    id='wishlist.goMyAccount'
  />
);
